export enum ProductTransactionReasonForFailure {
  product_master_data_not_serial_managed = 'PRODUCT_TRANSACTION_PRODUCT_MASTER_DATA_NOT_SERIAL_MANAGED',
  product_master_data_not_lpn_managed = 'PRODUCT_TRANSACTION_PRODUCT_MASTER_DATA_NOT_LPN_MANAGED',
  product_master_data_not_lot_managed = 'PRODUCT_TRANSACTION_PRODUCT_MASTER_DATA_NOT_LOT_MANAGED',
  bin_no_outbound_allowed = 'PRODUCT_TRANSACTION_NO_OUTBOUND_ALLOWED',
  bin_no_inbound_allowed = 'PRODUCT_TRANSACTION_NO_INBOUND_ALLOWED',
  quantity_negative = 'PRODUCT_TRANSACTION_QUANTITY_NEGATIVE',
  quantity_zero = 'PRODUCT_TRANSACTION_QUANTITY_ZERO',
  quantity_serial = 'PRODUCT_TRANSACTION_QUANTITY_SERIAL',
  quantity_lpn = 'PRODUCT_TRANSACTION_QUANTITY_LPN',
  interal_error = 'PRODUCT_TRANSACTION_INTERNAL_ERROR',
  manual_rollback = 'PRODUCT_TRANSACTION_MANUAL_ROLLBACK',
  multiple_products_found = 'PRODUCT_TRANSACTION_MULTIPLE_PRODUCTS_FOUND',
  processed_quantity_to_big = 'PRODUCT_TRANSACTION_PROCESSED_QUANTITY_TO_BIG',
  product_master_data_id_missing = 'PRODUCT_TRANSACTION_PRODUCT_MASTER_DATA_ID_MISSING',
  product_master_data_not_found = 'PRODUCT_TRANSACTION_PRODUCT_MASTER_DATA_NOT_FOUND',
  product_not_found = 'PRODUCT_TRANSACTION_PRODUCT_NOT_FOUND',
  product_master_data_not_defined = 'PRODUCT_TRANSACTION_PRODUCT_MASTER_DATA_NOT_DEFINED',
  to_bin_not_defined = 'PRODUCT_TRANSACTION_TO_BIN_NOT_DEFINED',
  from_bin_not_defined = 'PRODUCT_TRANSACTION_FROM_BIN_NOT_DEFINED',
  to_stock_location_not_defined = 'PRODUCT_TRANSACTION_TO_STOCK_LOCATION_NOT_DEFINED',
  from_stock_location_not_defined = 'PRODUCT_TRANSACTION_FROM_STOCK_LOCATION_NOT_DEFINED',
  serial_already_exists = 'PRODUCT_TRANSACTION_PRODUCT_WITH_SERIAL_ALREADY_EXISTS',
  lpn_already_exists = 'PRODUCT_TRANSACTION_PRODUCT_WITH_LPN_ALREADY_EXISTS',
  to_bin_not_found = 'PRODUCT_TRANSACTION_TO_BIN_NOT_FOUND',
  from_bin_not_found = 'PRODUCT_TRANSACTION_FROM_BIN_NOT_FOUND',
  to_container_not_found = 'PRODUCT_TRANSACTION_TO_CONTAINER_NOT_FOUND',
  from_container_not_found = 'PRODUCT_TRANSACTION_FROM_CONTAINER_NOT_FOUND',
  product_serial_not_found = 'PRODUCT_TRANSACTION_PRODUCT_SERIAL_NOT_FOUND',
  product_lpn_not_found = 'PRODUCT_TRANSACTION_PRODUCT_LPN_NOT_FOUND',
  serial_missing = 'PRODUCT_TRANSACTION_PRODUCT_SERIAL_MISSING',
  lpn_missing = 'PRODUCT_TRANSACTION_PRODUCT_LPN_MISSING',
  lot_missing = 'PRODUCT_TRANSACTION_PRODUCT_LOT_MISSING',
}

export function productTransactionReasonForFailureToString(code: string) {
  switch (code) {
    case ProductTransactionReasonForFailure.product_master_data_not_serial_managed:
      return 'Product Reference Data is not serial managed';
    case ProductTransactionReasonForFailure.product_master_data_not_lpn_managed:
      return 'Product Reference Data is not LPN managed';
    case ProductTransactionReasonForFailure.product_master_data_not_lot_managed:
      return 'Product Reference Data is not lot Managed';
    case ProductTransactionReasonForFailure.bin_no_outbound_allowed:
      return 'Selected bin does not allow outbound actions';
    case ProductTransactionReasonForFailure.bin_no_inbound_allowed:
      return 'Selected bin does not allow inbound actions';
    case ProductTransactionReasonForFailure.quantity_negative:
      return 'Quantity can not be negative';
    case ProductTransactionReasonForFailure.quantity_zero:
      return 'Quantity can not be zero';
    case ProductTransactionReasonForFailure.quantity_serial:
      return 'Quantity for a serialized product should be 1';
    case ProductTransactionReasonForFailure.quantity_lpn:
      return 'Quantity for a LPN product should be 1';
    case ProductTransactionReasonForFailure.interal_error:
      return 'Internal Error';
    case ProductTransactionReasonForFailure.manual_rollback:
      return 'Manual Rollback';
    case ProductTransactionReasonForFailure.multiple_products_found:
      return 'Multiple products found';
    case ProductTransactionReasonForFailure.processed_quantity_to_big:
      return 'The processed quantity is too big';
    case ProductTransactionReasonForFailure.product_master_data_id_missing:
      return 'Product Reference Id is missing';
    case ProductTransactionReasonForFailure.product_master_data_not_found:
      return 'Product Reference Item was not found';
    case ProductTransactionReasonForFailure.product_not_found:
      return 'Product was not found';
    case ProductTransactionReasonForFailure.product_master_data_not_defined:
      return 'Product Reference Data was not defined';
    case ProductTransactionReasonForFailure.to_bin_not_defined:
      return 'Destination bin was not defined';
    case ProductTransactionReasonForFailure.from_bin_not_defined:
      return 'Source bin was not defined';
    case ProductTransactionReasonForFailure.to_stock_location_not_defined:
      return 'Destination stock location was not defined';
    case ProductTransactionReasonForFailure.from_stock_location_not_defined:
      return 'Source stock location was not defined';
    case ProductTransactionReasonForFailure.serial_already_exists:
      return 'Product with this serial already exsists';
    case ProductTransactionReasonForFailure.lpn_already_exists:
      return 'Product with this LPN already exists';
    case ProductTransactionReasonForFailure.to_bin_not_found:
      return 'Destination bin not found';
    case ProductTransactionReasonForFailure.from_bin_not_found:
      return 'Source bin not found';
    case ProductTransactionReasonForFailure.to_container_not_found:
      return 'Destination container not found';
    case ProductTransactionReasonForFailure.from_container_not_found:
      return 'Source container not found';
    case ProductTransactionReasonForFailure.product_serial_not_found:
      return 'Product with serial was not found';
    case ProductTransactionReasonForFailure.product_lpn_not_found:
      return 'Product with LPN was not found';
    case ProductTransactionReasonForFailure.serial_missing:
      return 'Serial is missing';
    case ProductTransactionReasonForFailure.lpn_missing:
      return 'LPN is missing';
    case ProductTransactionReasonForFailure.lot_missing:
      return 'Lot is missing';
  }

  return code;
}
